import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTotalDiscountSummary = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.totalDiscountSummary, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTotalDiscountSummary(), {
        params,
      });

      const composeResponse = {
        clinicTotalDiscounts: res.data.data.clinic_total_discounts_summary,
        providerTotalDiscounts: res.data.data.provider_total_discounts_summary,
      };
      return composeResponse;
    },
    options,
  );
};
